
class SupportOrdersIteratorNonPaginatedCollection
  constructor: (ordersFilter, orderModel) ->
    @ordersFilter = ordersFilter
    @resetIterator()
    @size = 10
    if orderModel.hasOrders()
      @state = "SUCCESS"
      @ordersFilter.sortOrders( _.map(orderModel.orders, (order)-> order) )
    else
      @state = "NOT_STARTED"

  resetIterator: () ->
    @currentOrdersOffset = 0

  resetState: () ->
    @state

  hasNext: () ->
    if @isStateNotStarted()
      return true
    else if @isOrderCallQueued() || @currentOrdersOffset >= @getNumberOfOrdersFetched()
      return false
    return true

  next: (sucessCallback, errorCallback) ->
    if @hasNext()

      _sucessCb = () =>
        @state = "SUCCESS"
        offset = @currentOrdersOffset
        @currentOrdersOffset = Math.min(@currentOrdersOffset + @size, @getNumberOfOrdersFetched())
        sucessCallback(@ordersFilter.sortedOrders.slice(offset, (offset + @size)))

      if(@currentOrdersOffset < @getNumberOfOrdersFetched())
        _sucessCb()
      else
        options = {}
        @state = "QUEUED"

        _errorCb = () =>
          @state = "ERROR"
          errorCallback()

        @ordersFilter.getOrders(options, _sucessCb, _errorCb)

  isStateNotStarted: () ->
    @state is "NOT_STARTED"

  isOrderCallQueued: () ->
    @state is "QUEUED"

  hasOrderCallFailed: () ->
    @state is "ERROR"

  getNumberOfOrdersFetched: () ->
    @ordersFilter.sortedOrders.length

  getNumberOfItemPerPage: () ->
    @size

  isOrdersInfoValid: () ->
    not(@isStateNotStarted() ||  @hasOrderCallFailed())

module.exports = SupportOrdersIteratorNonPaginatedCollection
